import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "text-sm" }
const _hoisted_2 = { class: "grid" }
const _hoisted_3 = { class: "col-12 lg:col-6" }
const _hoisted_4 = { class: "p-float-label" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "col-12 lg:col-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_DashboardMap = _resolveComponent("DashboardMap")!
  const _component_Card = _resolveComponent("Card")!
  const _component_shipment_map = _resolveComponent("shipment-map")!
  const _component_Sidebar = _resolveComponent("Sidebar")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Card, { class: "m-2" }, {
      title: _withCtx(() => [
        _createTextVNode("ยินดีต้อนรับคุณ " + _toDisplayString(_ctx.store.name ?? "N/A") + " ", 1),
        _createElementVNode("span", _hoisted_1, "(" + _toDisplayString(_ctx.store.username) + ")", 1)
      ]),
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_DataTable, {
              value: _ctx.filteredDashboards,
              class: "p-datatable-sm",
              showGridlines: true,
              scrollable: "",
              scrollHeight: "70vh",
              loading: _ctx.isLoading
            }, {
              header: _withCtx(() => [
                _createElementVNode("span", _hoisted_4, [
                  _createVNode(_component_InputText, {
                    class: "p-inputtext-sm",
                    modelValue: _ctx.searchString,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchString) = $event)),
                    id: "searchString"
                  }, null, 8, ["modelValue"]),
                  _cache[2] || (_cache[2] = _createElementVNode("label", { for: "searchString" }, "ค้นหา", -1))
                ])
              ]),
              empty: _withCtx(() => _cache[3] || (_cache[3] = [
                _createTextVNode("ไม่พบข้อมูล")
              ])),
              footer: _withCtx(() => [
                _createTextVNode(" จำนวนพนักงานทั้งหมด " + _toDisplayString(_ctx.dashboards.length) + " ท่าน ", 1)
              ]),
              default: _withCtx(() => [
                _createVNode(_component_Column, {
                  field: "dman",
                  header: "Dman No.",
                  sortable: ""
                }),
                _createVNode(_component_Column, {
                  field: "dmanName",
                  header: "Name",
                  sortable: ""
                }),
                _createVNode(_component_Column, {
                  field: "plant",
                  header: "Office",
                  sortable: ""
                }, {
                  body: _withCtx((props) => [
                    _createElementVNode("div", {
                      class: "office-box mr-2",
                      style: _normalizeStyle({
                    backgroundColor: _ctx.salesOfficesColor[props.data.plant],
                  })
                    }, null, 4),
                    _createTextVNode(" " + _toDisplayString(props.data.plant), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  field: "shipmentNo",
                  header: "Shipment No.",
                  sortable: ""
                }, {
                  body: _withCtx((props) => [
                    _createElementVNode("span", {
                      class: "underline text-blue-500 cursor-pointer",
                      onClick: ($event: any) => (_ctx.showMap(props.data.shipmentNo))
                    }, _toDisplayString(parseInt(props.data.shipmentNo)), 9, _hoisted_5)
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  field: "timeStamp",
                  header: "เวลาที่ update",
                  sortable: ""
                }, {
                  body: _withCtx((props) => [
                    _withDirectives((_openBlock(), _createElementBlock("span", null, [
                      _createTextVNode(_toDisplayString(_ctx.formatDateTime(props.data.timeStamp)), 1)
                    ])), [
                      [_directive_tooltip, `${_ctx.dayjs(props.data.timeStamp).fromNow()}`]
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 2
            }, 1032, ["value", "loading"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_DashboardMap, {
              dashboards: _ctx.filteredDashboards,
              salesOfficesColor: _ctx.salesOfficesColor
            }, null, 8, ["dashboards", "salesOfficesColor"])
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_Sidebar, {
      visible: _ctx.showPopup,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.showPopup) = $event)),
      modal: "",
      position: "full"
    }, {
      default: _withCtx(() => [
        (_ctx.selectedShipment)
          ? (_openBlock(), _createBlock(_component_shipment_map, {
              key: 0,
              shipmentNo: _ctx.selectedShipment
            }, null, 8, ["shipmentNo"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}